"use client"
import { ICustomImage, Trailer } from '@filmweb/sanity-types';
import { useState } from 'react';
import ImageGalleryPlaceholder from "src/components/imagegallery/ImageGalleryPlaceholder";
import CmsImage from 'src/components/images/CmsImage';
import PlaySvg from 'src/components/svg/PlaySvg';
import TrailerOverlayWrapper from 'src/components/traileroverlaywrapper/TrailerOverlayWrapper';
import classNames from 'classnames';
import styles from './NewsTopImage.module.css';
import IFilmklipp from "src/lib/types/Filmklipp";
import { IFilmomtale } from "src/lib/types/Filmomtale";
import IGallery from "src/lib/types/IGallery";


//#region [Props]
type NewsTopImageProps = {
    topImage?: ICustomImage;
    gallery?: IFilmomtale | IGallery;
    video?: Trailer | IFilmklipp;
    isContentAd: boolean;
    imageText?: string;
};
//#endregion

//#region [Component]
export default function NewsTopImage({ topImage, video, gallery, isContentAd, imageText }: NewsTopImageProps) {
    const [showVideo, setShowVideo] = useState(false);
    let _topImage: ICustomImage | undefined;
    let _images: ICustomImage[] | undefined;
    let isGallery = false;
    switch (gallery?._type) {
        case "filmomtale":
            _topImage = gallery?.mainImageGalleryV2 ?? gallery?.imagesOverrideV2?.[0] ?? gallery?.imagesV2?.[0];
            _images = (gallery?.imagesOverrideV2?.length ?? 0) > 0 ? gallery?.imagesOverrideV2 : gallery?.imagesV2;
            isGallery = true;
            break;
        case "gallery":
            _topImage = gallery?.images?.[0];
            _images = gallery?.images;
            isGallery = true;
            break;
        default:
            _topImage = topImage;
    }
    if (!_topImage || _topImage?.asset?.isOkForCopyrightUse !== true) {
        return null;
    }
    const copyright = buildImageText(_topImage);
    const showFigCaption = (!_topImage.fomId && copyright) || imageText?.trim();
    return <>
        <figure 
            className={classNames(styles.STopImageContainer, {
                [styles.hasTrailer]: !!video,
                [styles.contentAd]: isContentAd
            })} 
            onClick={() => setShowVideo(!!video)}
        >
            {isGallery && <ImageGalleryPlaceholder placeholderImage={_topImage} placeholderSizes={`(min-width: 1640px): 1640px, 100vw`} placeholderAspect={2 / 1} images={_images} placeholderPriority placeholderUnoptimized />}
            {!isGallery && <CmsImage 
                className={styles.STopImage}
                alt={_topImage.asset.altText ?? _topImage.asset.title ?? ""}
                image={_topImage}
                sizes={`(min-width: 1640px): 1640px, 100vw`}
                priority />}
            {!isGallery && video && <PlaySvg className={styles.STopClipPlaySvg} />}
            {showFigCaption && <figcaption className={styles.SImageCredits}>
                {imageText?.trim() && <span>{imageText}</span>}
                {!_topImage.fomId && copyright && <span>Foto: {copyright}</span>}
            </figcaption>}
        </figure>
        {!isGallery && showVideo && video && <TrailerOverlayWrapper video={video} onClose={() => setShowVideo(false)} />}
    </>;
}

function buildImageText(img: ICustomImage): string {
    const text = img.asset.copyright?.trim() ?? "";
    return text.trim();
}
//#endregion

